/**
 * Routine の締めの確定の印刷ページ(2026-10-23・/routine/print/:id)。サイドバーなしの単独レイアウト(請求書・受領書の印刷ページと同じ作り)。
 * 中身は RoutineStatement(Routine の PDF と同じ形)。「印刷する」からブラウザの印刷で PDF にも保存できる。
 * ①の作業内訳は A4 横、②③は A4 縦。読めるのは経理・承認者・管理者(権限ルール)。同じタブで開き、「戻る」で元の画面へ
 */
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMasters } from '@core/masters/MastersProvider';
import type { RoutineClosing } from '@core/lib/types';
import { STAGE_LABELS, monthLabel } from './routineClosing';
import { fetchRoutineClosing } from './routineClosingRepo';
import RoutineStatement, { issuerFromCompanies } from './RoutineStatement';

export default function RoutineClosingPrintPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { companies } = useMasters();
  const [closing, setClosing] = useState<RoutineClosing | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    fetchRoutineClosing(id)
      .then((c) => (c ? setClosing(c) : setError('Routine の確定が見つかりません')))
      .catch((e) => setError(e instanceof Error ? e.message : '読み込めませんでした'));
  }, [id]);

  if (error) return <p style={{ padding: 24 }}>{error}</p>;
  if (!closing) return <p style={{ padding: 24 }}>読み込み中…</p>;
  const landscape = closing.detail.kind === 'billing';

  return (
    <div className="rt-print" style={{ background: '#fff', minHeight: '100vh' }}>
      <style>{`
        @media print { .no-print { display: none !important; } body { background: #fff; } .rt-print-sheet { margin: 0; max-width: none; } }
        @page { size: A4 ${landscape ? 'landscape' : 'portrait'}; margin: 12mm; }
      `}</style>
      <div className="no-print" style={{ padding: '12px 16px', background: '#F4F7FB', borderBottom: '1px solid #ddd', display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <b>
          {STAGE_LABELS[closing.stage]}: {closing.name}({monthLabel(closing.month)}分)
        </b>
        <span style={{ fontSize: 12.5, color: '#666' }}>「印刷する」で PDF にも保存できます{landscape ? '(A4 横)' : ''}</span>
        <button className="btn-line" style={{ marginLeft: 'auto' }} onClick={() => navigate(-1)}>
          戻る
        </button>
        <button className="btn-green" onClick={() => window.print()}>
          印刷する
        </button>
      </div>
      <div className={`rt-print-sheet${landscape ? ' landscape' : ''}`}>
        <RoutineStatement closing={closing} issuer={issuerFromCompanies(companies)} />
      </div>
    </div>
  );
}
